import { render } from "./AdmTable.vue?vue&type=template&id=e2065a82&scoped=true"
import script from "./AdmTable.vue?vue&type=script&lang=js"
export * from "./AdmTable.vue?vue&type=script&lang=js"

import "./AdmTable.vue?vue&type=style&index=0&id=e2065a82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2065a82"]])

export default __exports__